<mat-form-field class="search__box">
  <i matPrefix class="fa fa-search padding-right-1 search__icon"></i>
  <mat-label>{{ getSearchLabel() | titlecase }}</mat-label>
  <input matInput #basicSearchBox data-cy="basicSearchBox" id="basicSearchBox" [formControl]="minLengthValidator" />
  <i matSuffix class="fa fa-times search__x" (click)="clearSearch()"></i>
  <mat-error *ngIf="minLengthValidator.invalid">Search must be at least 3 characters.</mat-error>
</mat-form-field>
